import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e03dd104&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e03dd104&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03dd104",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e03dd104')) {
      api.createRecord('e03dd104', component.options)
    } else {
      api.reload('e03dd104', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e03dd104&scoped=true", function () {
      api.rerender('e03dd104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TermsOfUsePdfViewer/index.vue"
export default component.exports